export default (text, length = '15') => `${text?.slice(0, length)}...`
